import { lazy, Suspense } from 'react';
import "./Footer.css";

const Timer = lazy(() => import('./Timer.tsx')); // Новый компонент

const Footer = () => {
  return (
    <div id="footer">
      <div className="footer">
        <div className="ilike">
          <p>Если сайт Вам понравился и оказался для Вас полезным, то поделитесь им.</p>
          <div className="ilike_but_top">
            <div className="share42init">
              <span id="share42"></span>
            </div>
          </div>
          <Suspense fallback={<div>00 00 00 00</div>}>
            <Timer />
          </Suspense>
          <div className="ilike_but_bot"></div>
        </div>
        <div className="copy">
          <p>Все права защищены Ⓒ 2011-2025 Официальный сайт Сергея Мавроди</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;